import React, { useState } from 'react';
import { X, Move, MapPin, Layers, Save, Search, List, Calendar } from 'lucide-react';
import toast from 'react-hot-toast';
import api from './axiosConfig';
import UniversalLookup from './UniversalLookup';

const MoveAssetModal = ({ isOpen, onClose, asset, onRefresh }) => {
    const [lookup, setLookup] = useState({ isOpen: false, title: '', type: '', domainId: '', field: '', onCustomSelect: null });
    const [fieldMaps, setFieldMaps] = useState({}); // ???? ?? ????? ?? ???? DOMAINs
    const [formData, setFormData] = useState({
        assetnum: asset?.assetnum,
        new_location: asset?.location || '',
        new_parent: asset?.parent || '',
        new_bin: asset?.bin || '',
        memo: '' // ????? ????????? ??? ?????? ???????
    });

    if (!isOpen) return null;

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSmartSearch = (fieldName, title, defaultType, onCustomSelect = null) => {
        const linkedDomain = (fieldMaps || {})[fieldName];
        setLookup({
            isOpen: true,
            title,
            type: linkedDomain ? 'DOMAIN' : defaultType,
            domainId: linkedDomain || '',
            field: fieldName,
            onCustomSelect: onCustomSelect
        });
    };

    const handleMove = async () => {
        // ???? ?? ??? assetnum ????? ??? undefined
        if (!asset?.assetnum) {
            toast.error("Error: Asset Number is missing");
            return;
        }
    
        const loadId = toast.loading("Executing Move/Modify...");
        try {
            const payload = {
                assetnum: asset.assetnum, // ????? ?? ???? ????? ???? ???????? ??????
                new_location: formData.new_location,
                new_parent: formData.new_parent,
                new_bin: formData.new_bin,
                memo: formData.memo
            };
    
            console.log("?? Move Payload:", payload); // ??? Debug ???? ???? ?????? ??? ?????
    
            await api.post('/api/assets/move', payload);
            toast.success("Asset Hierarchy Updated", { id: loadId });
            if (onRefresh) onRefresh();
            onClose();
        } catch (err) {
            console.error("? Move Error Details:", err.response?.data);
            toast.error(err.response?.data?.detail || "Move Failed", { id: loadId });
        }
    };

    return (
        <div className="fixed inset-0 z-[10005] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in duration-300">
            {/* ???? ????? ?????? */}
            <UniversalLookup
                {...lookup}
                onClose={() => setLookup({ ...lookup, isOpen: false })}
                onSelect={(row) => {
                    // 1. ??????: ?? ????? ??????? ?? ???? ????? ???????
                    const selectedVal = row.assetnum || row.location_id || row.value || row.id;
                    
                    if (lookup.field === 'new_parent' && selectedVal === asset?.assetnum) {
                        toast.error("Invalid Operation: An asset cannot be its own parent!", {
                            style: { fontWeight: 'bold', fontSize: '12px' }
                        });
                        return; // ???? ??????? ??? ????? ????? ?? ???? ????? ???? ????
                    }
            
                    // 2. ?? ????? ??? ??????? ??????
                    if (lookup.onCustomSelect) {
                        lookup.onCustomSelect(row);
                    } else {
                        handleInputChange(lookup.field, selectedVal);
                    }
                    setLookup(prev => ({ ...prev, isOpen: false }));
                }}
            />

            <div className="bg-[#f0f0f0] w-[550px] shadow-2xl border border-gray-300 rounded-sm flex flex-col overflow-hidden">
                
                {/* Header - IBM Blue */}
                <div className="bg-[#005495] text-white p-3 flex justify-between items-center shadow-md">
                    <div className="flex items-center gap-2">
                        <Move size={18} className="text-blue-200" />
                        <div className="flex flex-col">
                            <span className="font-black text-[11px] uppercase tracking-tighter">Move / Modify Asset</span>
                            <span className="text-[9px] text-blue-200 font-bold uppercase italic">ID: {asset?.assetnum}</span>
                        </div>
                    </div>
                    <button onClick={onClose} className="hover:bg-red-600 p-1 rounded transition-colors text-white">
                        <X size={20} />
                    </button>
                </div>

                <div className="p-5 space-y-5">
                    {/* Current Context Strip - Read Only */}
                    <div className="bg-white border border-gray-200 p-3 rounded-sm shadow-sm grid grid-cols-2 gap-4">
                        <div className="border-r border-gray-100 pr-4">
                            <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Current Location</p>
                            <p className="text-blue-900 font-black text-xs italic">{asset?.location || 'Unassigned'}</p>
                        </div>
                        <div className="pl-2">
                            <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest mb-1">Current Parent</p>
                            <p className="text-blue-900 font-black text-xs italic">{asset?.parent || 'Top Level'}</p>
                        </div>
                    </div>

                    {/* New Assignments Form */}
                    <div className="bg-white border border-gray-300 p-5 space-y-6 shadow-inner relative overflow-hidden">
                        <div className="absolute top-0 right-0 p-1 bg-orange-100 text-orange-700 text-[8px] font-black uppercase">Modification Entry</div>
                        
                        {/* New Location with Search */}
                        <EditableField 
                            label="New Location" 
                            value={formData.new_location} 
                            onChange={(val) => handleInputChange('new_location', val)} 
                            onSearch={() => handleSmartSearch('new_location', 'Locations Lookup', 'locations')}
                            icon={<MapPin size={14} className="text-blue-500" />}
                            desc="Target Location ID"
                        />

                        {/* New Parent with Search */}
                        <EditableField 
                            label="New Parent Asset" 
                            value={formData.new_parent} 
                            onChange={(val) => handleInputChange('new_parent', val)} 
                            onSearch={() => handleSmartSearch(
                                'new_parent', 
                                'Assets Lookup (Excluding Current)', 
                                'assets',
                                null, // No custom select
                                `assetnum_not=${asset?.assetnum}` // ????? ?? ??? API ????? ??????? ??
                            )}
                            icon={<Layers size={14} className="text-orange-500" />}
                        />

                        {/* Reason / Memo */}
                        <div className="flex flex-col gap-1 border-b border-gray-200">
                            <label className="text-gray-400 font-black text-[9px] uppercase tracking-tighter">Move Reason (Memo)</label>
                            <input 
                                className="outline-none font-bold text-gray-700 bg-transparent py-1 text-xs" 
                                placeholder="Write reason for this move..."
                                value={formData.memo}
                                onChange={(e) => handleInputChange('memo', e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* Action Footer */}
                <div className="bg-gray-100 p-4 border-t flex justify-end gap-3 shadow-inner">
                    <button 
                        onClick={onClose} 
                        className="px-6 py-2 text-[10px] font-black uppercase text-gray-500 hover:bg-white border border-transparent hover:border-gray-300 transition-all"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={handleMove}
                        className="bg-[#005495] text-white px-10 py-2 text-[10px] font-black uppercase flex items-center gap-2 hover:bg-blue-800 shadow-xl transition-all"
                    >
                        <Save size={16} /> OK / EXECUTE MOVE
                    </button>
                </div>
            </div>
        </div>
    );
};

// ???? ????? ?????? ????? ???? ???????? ???????
const EditableField = ({ label, value, onChange, onSearch, icon, desc, type = "text" }) => (
    <div className="flex flex-col gap-1 border-b border-gray-300 group hover:border-blue-500 transition-all">
        <label className="text-gray-400 font-black text-[9px] uppercase tracking-tighter flex items-center gap-1">
            {icon} {label}
        </label>
        <div className="flex items-center justify-between pb-1">
            <input 
                type={type} 
                className="outline-none font-black text-blue-900 bg-transparent w-full text-xs uppercase" 
                value={value || ''} 
                onChange={e => onChange && onChange(e.target.value)} 
            />
            <div className="flex gap-3">
                {desc && <span className="text-[9px] text-gray-300 font-normal italic whitespace-nowrap hidden md:block">{desc}</span>}
                {onSearch && (
                    <Search 
                        size={15} 
                        className="text-blue-400 cursor-pointer hover:text-blue-800 hover:scale-110 transition-all" 
                        onClick={onSearch} 
                    />
                )}
            </div>
        </div>
    </div>
);



export default MoveAssetModal;